<template lang="pug">
  div
    //- As this progress bar is starting under the blue circle (centered), it needs to be shifted  to the right
    //- so that the progress bar matches the advance of the form in terms of look & feel => '.ml-8'
    .bg-gray-250.h-2-px.ml-8(v-if="!lastChild" :class="customClasses")
      .h-full.rounded.transition-width.duration-500.ease-in-out(:class="activeBackgroundClass" :style="{width: progressBarWidth}")
    .-ml-1.-mt-6
      .h-10.w-10.rounded-full.text-white.flex.items-center.justify-center(:class="stepClass")
        b {{ step }}
      .flex(class='lg:-ml-8')
        b.pr-1.text-sm(:class="titleClass" class='lg:text-base')
          slot
        b.text-sm.mt-1(:class="textClass") {{ progressPercentageText }}
</template>

<script>
  export default {
    name: 'SwStep',
    props: {
      customClasses: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      step: {
        type: Number,
        required: true,
      },
      activeColor: {
        type: String,
        default: 'blue-500',
      },
      lastChild: {
        type: Boolean,
        default: false,
      },
      active: {
        type: Boolean,
        default: false,
      },
      completed: {
        type: Boolean,
        default: false,
      },
      progressPercentage: {
        type: Number,
        default: 0,
        validator: value => value >= 0 && value <= 100,
      },
    },
    computed: {
      titleClass () {
        return this.active ? 'text-gray-900' : 'md:contents md:text-gray-250';
      },
      stepClass () {
        return this.active || this.completed ? `bg-${this.activeColor}` : 'bg-gray-250';
      },
      textClass () {
        return `hidden lg:flex text-${this.activeColor}`;
      },
      activeBackgroundClass () {
        return `bg-${this.activeColor}`;
      },
      progressBarWidth () {
        if (this.completed) return '100%';
        return this.active ? `${this.progressPercentage}%` : '0%';
      },
      progressPercentageText () {
        return this.active ? `(${this.progressPercentage}%)` : '';
      },
    },
  };
</script>
